
export default function Services() {
  const services = [
    {
      icon: 'ri-window-line',
      title: 'Medical Website Design',
      description: 'HIPAA-compliant, conversion-optimized websites built specifically for healthcare providers with patient-focused design and secure forms.',
      features: ['Mobile-First Design', 'HIPAA-Secure Forms', 'Fast Loading', 'Patient Booking Integration']
    },
    {
      icon: 'ri-search-line',
      title: 'Medical SEO & Local SEO',
      description: 'Dominate local search results and attract qualified patients actively searching for your healthcare services in your area.',
      features: ['Google Business Optimization', 'Healthcare Keywords', 'Local Citations', 'Medical Content Strategy']
    },
    {
      icon: 'ri-advertisement-line',
      title: 'Healthcare PPC Advertising',
      description: 'HIPAA-compliant Google Ads and Meta campaigns that generate qualified patient leads while maintaining compliance.',
      features: ['Google Ads Management', 'Meta Ads for Healthcare', 'Compliant Targeting', 'ROI Tracking']
    },
    {
      icon: 'ri-star-line',
      title: 'Reputation Management',
      description: 'Build trust and authority with strategic review generation and management across all major healthcare platforms.',
      features: ['Review Generation', 'Response Management', 'Rating Improvement', 'Trust Building']
    },
    {
      icon: 'ri-article-line',
      title: 'Medical Content Marketing',
      description: 'Authority-building content that educates patients, improves SEO, and positions you as the trusted healthcare expert.',
      features: ['Medical Blog Writing', 'Patient Education', 'SEO Content', 'Email Campaigns']
    },
    {
      icon: 'ri-share-line',
      title: 'Healthcare Social Media',
      description: 'Compliant social media marketing that builds community, educates patients, and drives appointment bookings.',
      features: ['Content Creation', 'Community Management', 'HIPAA-Safe Posting', 'Patient Engagement']
    },
    {
      icon: 'ri-robot-2-line',
      title: 'Marketing Automation & CRM',
      description: 'Automated lead nurturing system that follows up with every inquiry, books appointments, and never misses a patient.',
      features: ['Automated Follow-Up', 'Lead Nurturing', 'CRM for Healthcare', 'Pipeline Management']
    },
    {
      icon: 'ri-chat-smile-3-line',
      title: 'AI Patient Engagement',
      description: 'AI-powered chatbots and lead capture tools that qualify patients 24/7 while maintaining HIPAA compliance.',
      features: ['24/7 Chat Support', 'Lead Qualification', 'Appointment Booking', 'HIPAA-Compliant AI']
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Analytics & ROI Reporting',
      description: 'Comprehensive tracking and reporting that shows exactly how your marketing investment drives patient growth.',
      features: ['Custom Dashboards', 'Patient Attribution', 'ROI Analysis', 'Performance Tracking']
    }
  ];

  return (
    <section id="services" className="py-24 px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-[#7C3AED] font-bold mb-4">
              HEALTHCARE MARKETING SERVICES
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6">
              Complete Digital Marketing Solutions for Healthcare Providers
            </h2>
            <p className="text-base text-gray-600 leading-relaxed">
              Every service is built specifically for healthcare and implemented with HIPAA-aware processes to protect patient data and maintain compliance.
            </p>
          </div>
          <div className="relative">
            <div className="w-full h-80 rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/6c70faedda7023ca0da6174a61a82c17.jpg"
                alt="Healthcare marketing team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl p-4 shadow-xl">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-gradient-to-br from-[#7C3AED] to-[#A855F7] rounded-lg flex items-center justify-center">
                  <i className="ri-shield-check-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-sm font-bold text-gray-900">HIPAA Compliant</div>
                  <div className="text-xs text-gray-500">All Services</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-[#F9FAFB] rounded-xl p-8 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer border border-gray-100"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-[#7C3AED] to-[#A855F7] rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              
              <p className="text-gray-600 mb-6 leading-relaxed text-sm">
                {service.description}
              </p>

              <div className="space-y-2">
                {service.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <div className="w-4 h-4 bg-[#7C3AED]/10 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-[#7C3AED] text-xs"></i>
                    </div>
                    <span className="text-gray-700 text-sm">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-[#7C3AED] to-[#A855F7] text-white px-8 py-4 rounded-lg hover:from-[#6D28D9] hover:to-[#9333EA] transition-all cursor-pointer whitespace-nowrap font-medium"
          >
            <span>Get Your Custom Growth Plan</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
